/** Shows a direct route back to review only after the user chooses to edit it. */
export function createReviewReturn(form: HTMLFormElement, label: string, pendingLabel: string) {
  let active = false;
  let busy = false;
  const actions = Array.from(form.querySelectorAll<HTMLElement>('[data-data-stage] .stage-actions'), actions => {
    const original = actions.querySelector<HTMLElement>('[data-stage-next], #previewBtn')!;
    const originallyHidden = original.classList.contains('hidden');
    const button = document.createElement('button');
    button.type = 'submit'; button.className = 'btn btn-primary hidden';
    button.dataset.reviewReturn = '';
    button.textContent = label;
    actions.append(button);
    return { original, originallyHidden, button };
  });
  const sync = () => {
    for (const { original, originallyHidden, button } of actions) {
      original.classList.toggle('hidden', active || originallyHidden);
      button.classList.toggle('hidden', !active);
      button.disabled = busy;
      button.textContent = busy ? pendingLabel : label;
    }
  };
  return {
    get active() { return active; },
    setActive(value: boolean) { active = value; sync(); },
    setBusy(value: boolean) { busy = value; sync(); },
    dispose() {
      for (const { original, originallyHidden, button } of actions) {
        original.classList.toggle('hidden', originallyHidden); button.remove();
      }
    },
  };
}
